import FormImageUploader from 'components/FormImageUploader/FormImageUploader';
import {
	CreateSubcategoryContext,
	ICreateSubcategoryContext,
} from '../../../createSubcategoryState/createSubcategoryContext';
import React, { useContext } from 'react';
import { InputFields } from './components/InputFields';
import style from './CreationForm.module.scss';

const descriptionOfAspectRatio = {
	horizontal: {
		ratio: '18:13',
		optimalResolutions: {
			a: '324*234px',
			b: '648*468px',
		},
	},
	vertical: {
		ratio: '25:13',
		optimalResolutions: {
			a: '500*260px',
			b: '1000*520px',
		},
	},
};

export const CreationForm: React.FC = () => {
	const { setFileId, fileId } = useContext<ICreateSubcategoryContext>(CreateSubcategoryContext);

	const deletePhotoHandler = () => {
		setFileId(null);
	};

	return (
		<div className={style.container} data-test="CreationForm">
			<FormImageUploader
				containerClass={style.imageUploader}
				maxFileSizeMB={1}
				fileId={fileId}
				deletePhotoHandler={deletePhotoHandler}
				setFileId={setFileId}
				horizontalAspectRatio={324 / 234}
				verticalAspectRatio={500 / 260}
				descriptionOfAspectRatio={descriptionOfAspectRatio}
			/>
			<InputFields />
		</div>
	);
};
